// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menubar__next.active[data-v-a656203e],.menubar__previous.active[data-v-a656203e]{display:block!important}", ""]);
// Exports
module.exports = exports;
